import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Chargers = lazy(() => import('./chargers'));

export function ChargersPage() {
  return (
    <article className="space-y-6" data-testid="chargers-page">
      <Suspense fallback={<Loading />}>
        <Chargers />
      </Suspense>
    </article>
  );
}
